import React from "react";
import PropTypes from "prop-types";
import { SGModal } from "../../component";
import { SGSearchIcon } from "../../icons";
import "./SGPicModalCarousel-style.css";

export const SGPicModalCarousel = props => {
  let className = "cursor-pointer ";
  if (props.className) className += props.className;

  return (
    <>
      <div 
        className={className}
        data-toggle="modal"
        data-target={"#".concat(props.dataTarget)}
      >
        <div className="sg-pic-modal-carousel-div">
          <img className="sg-pic-modal-carousel" src={props.src} alt="..." />
          <SGSearchIcon className="sg-pic-modal-carousel-search" />
        </div>
      </div>
      <SGModal dataTarget={props.dataTarget} carouselPics={props.carouselPics} />
    </>
  );
};

SGPicModalCarousel.propTypes = {
  dataTarget: PropTypes.string,
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  carouselPics: PropTypes.array
};
